"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenP2pRemindYourPropertyAnalyticsEvent = exports.ScreenP2pPropertySetupStartAnalyticsEvent = exports.ScreenP2pPropertyFinishedSignupAnalyticsEvent = exports.ScreenP2pPropertyConfirmAnalyticsEvent = exports.ScreenP2pInviteYourPropertyAnalyticsEvent = exports.ScreenP2pHowItWorksAnalyticsEvent = exports.P2pSetupGotoHomeClickedAnalyticsEvent = exports.P2pRemindYourPropertySendCtaClickedAnalyticsEvent = exports.P2pRemindYourPropertyLaterCtaClickedAnalyticsEvent = exports.P2pPropertySetupStartCtaClickedAnalyticsEvent = exports.P2pPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = exports.P2pPropertyConfirmResendCtaClickedAnalyticsEvent = exports.P2pPropertyConfirmPortalClickAnalyticsEvent = exports.P2pInviteYourPropertyShareClickedAnalyticsEvent = exports.P2pInviteYourPropertyCtaClickedAnalyticsEvent = exports.P2pInviteYourPropertyCopyClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user lands on the p2p How It Works screen in the Onboarding Flow
 */
var ScreenP2pHowItWorksAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_how_it_works');
exports.ScreenP2pHowItWorksAnalyticsEvent = ScreenP2pHowItWorksAnalyticsEvent;
/**
 * Triggers when user lands on the p2p Property Setup Start screen in the Onboarding Flow
 */
var ScreenP2pPropertySetupStartAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_property_setup_start');
exports.ScreenP2pPropertySetupStartAnalyticsEvent = ScreenP2pPropertySetupStartAnalyticsEvent;
/**
 * Triggers when user clicks continue button on the p2p Property Setup Start screen in the Onboarding Flow
 */
var P2pPropertySetupStartCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_property_setup_start_cta_clicked');
exports.P2pPropertySetupStartCtaClickedAnalyticsEvent = P2pPropertySetupStartCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the p2p Invite Your Property screen in the Onboarding Flow
 */
var ScreenP2pInviteYourPropertyAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_invite_your_property');
exports.ScreenP2pInviteYourPropertyAnalyticsEvent = ScreenP2pInviteYourPropertyAnalyticsEvent;
/**
 * Triggers when user clicks share button on the p2p Invite Your Property screen in the Onboarding Flow
 */
var P2pInviteYourPropertyShareClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_invite_your_property_share_clicked');
exports.P2pInviteYourPropertyShareClickedAnalyticsEvent = P2pInviteYourPropertyShareClickedAnalyticsEvent;
/**
 * Triggers when user clicks copy button on the p2p Invite Your Property screen in the Onboarding Flow
 */
var P2pInviteYourPropertyCopyClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_invite_your_property_copy_clicked');
exports.P2pInviteYourPropertyCopyClickedAnalyticsEvent = P2pInviteYourPropertyCopyClickedAnalyticsEvent;
/**
 * Triggers when user clicks "Ive invited them" button on the p2p Invite Your Property screen in the Onboarding Flow
 */
var P2pInviteYourPropertyCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_invite_your_property_cta_clicked');
exports.P2pInviteYourPropertyCtaClickedAnalyticsEvent = P2pInviteYourPropertyCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the p2p Remind Your Property screen in the Onboarding Flow
 */
var ScreenP2pRemindYourPropertyAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_remind_your_property');
exports.ScreenP2pRemindYourPropertyAnalyticsEvent = ScreenP2pRemindYourPropertyAnalyticsEvent;
/**
 * Triggers when user clicks "Send" button on the p2p Remind Your Property screen in the Onboarding Flow
 */
var P2pRemindYourPropertySendCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_remind_your_property_send_cta_clicked');
exports.P2pRemindYourPropertySendCtaClickedAnalyticsEvent = P2pRemindYourPropertySendCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks "Later" button on the p2p Remind Your Property screen in the Onboarding Flow
 */
var P2pRemindYourPropertyLaterCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_remind_your_property_later_cta_clicked');
exports.P2pRemindYourPropertyLaterCtaClickedAnalyticsEvent = P2pRemindYourPropertyLaterCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the p2p Property Confirm screen in the Onboarding Flow
 */
var ScreenP2pPropertyConfirmAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_property_confirm');
exports.ScreenP2pPropertyConfirmAnalyticsEvent = ScreenP2pPropertyConfirmAnalyticsEvent;
/**
 * Triggers when user clicks "Portal" button on the p2p Property Confirm screen in the Onboarding Flow
 */
var P2pPropertyConfirmPortalClickAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_property_confirm_portal_click');
exports.P2pPropertyConfirmPortalClickAnalyticsEvent = P2pPropertyConfirmPortalClickAnalyticsEvent;
/**
 * Triggers when user clicks "Resend" button on the p2p Property Confirm screen in the Onboarding Flow
 */
var P2pPropertyConfirmResendCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_property_confirm_resend_cta_clicked');
exports.P2pPropertyConfirmResendCtaClickedAnalyticsEvent = P2pPropertyConfirmResendCtaClickedAnalyticsEvent;
/**
 * Triggers when user lands on the p2p Property Finished Signup screen in the Onboarding Flow
 */
var ScreenP2pPropertyFinishedSignupAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_property_finished_signup');
exports.ScreenP2pPropertyFinishedSignupAnalyticsEvent = ScreenP2pPropertyFinishedSignupAnalyticsEvent;
/**
 * Triggers when user clicks "Continue" button on the p2p Property Finished Signup screen in the Onboarding Flow
 */
var P2pPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_property_finished_signup_generic_cta_clicked');
exports.P2pPropertyFinishedSignupGenericCtaClickedAnalyticsEvent = P2pPropertyFinishedSignupGenericCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'Go back to to home' button to return to home screen
 */
var P2pSetupGotoHomeClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('p2p_setup_goto_home_clicked');
exports.P2pSetupGotoHomeClickedAnalyticsEvent = P2pSetupGotoHomeClickedAnalyticsEvent;
